@let footerTemplate = footer();
@let footerIsPinned = pinFooter();
<div fxLayout="column" class="container" fxLayoutAlign="start stretch">
  @if (header(); as header) {
    <div class="header">
      <ng-container [ngTemplateOutlet]="header"></ng-container>
    </div>
  }
  <div class="content" #content>
    <ng-content></ng-content>
    @if (!footerIsPinned && footerTemplate) {
      <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
    }
  </div>
  @if (footerIsPinned && footerTemplate) {
    <div class="footer">
      <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
    </div>
  }
</div>
